module.exports = __webpack_public_path__ + "static/media/route.a46a38df.svg";